/** @jsx jsx */

import type { WithDataAttributeProp } from '@balance-web/core';
import { getTestIdFromDataAttributes, jsx } from '@balance-web/core';
import { Text } from '@balance-web/text';
import { forwardRefWithAs, makeIdFactory } from '@balance-web/utils';
import { useContext, useMemo } from 'react';

import { FieldContext } from './context';

const FieldMessageIdFactory = makeIdFactory('field-message');

type MessageProps = WithDataAttributeProp<{
  /** The ID of the element. */
  id?: string;
}>;

export const FieldMessage = forwardRefWithAs<'div', MessageProps>(
  (props, ref) => {
    const testids = FieldMessageIdFactory();
    const fieldContext = useContext(FieldContext);
    const testid = useMemo(() => {
      const existing = getTestIdFromDataAttributes(props.data);
      if (existing) {
        return existing;
      }

      if (props.id) {
        return testids.base(props.id);
      }

      return testids.base(fieldContext?.id);
    }, []);

    return (
      <Text
        ref={ref}
        color="critical"
        data={{ testid }}
        data-balance-component="field-message"
        overflowStrategy="wrap"
        size="small"
        {...props}
      />
    );
  }
);
